import React from 'react';
import { Grid, FormControlLabel, Checkbox, Typography } from '@mui/material';

const TabTen = ({ 
  timesheetData, 
  setTimesheetData,
  taskAssignmentData,
  setTaskAssignmentData,
  timeEntryData,
  setTimeEntryData,
  detailReportData,
  setDetailReportData,
  summarizedReportData,
  setSummarizedReportData,
  taskBasedReportData,
  setTaskBasedReportData,
  varianceReportData,
  setVarianceReportData,
  setEmployeeTimesheetData,
  EmployeTimesheetData,
  onClickAll, 
  isEdit}) => {
  return (
    <>
      <Grid container>
        <Grid item xs={12} sx={{ mt: 1 }}>
          <Typography sx={{ pt: 2 }} variant="h5">
            Activity Management
          </Typography>
        </Grid>
        <Grid item xs={12} sx={{ mt: 2 }}>
          <FormControlLabel
            id="work-model-form-all"
            control={
              <Checkbox
                id="work-model-all"
                disabled={isEdit}
                checked={timesheetData.every((dash) => dash.value)}
                onClick={(e) =>
                  onClickAll(timesheetData, 'common', setTimesheetData, e)
                }
              />
            }
            label="All"
          />
        </Grid>
        {timesheetData.map((data, index) => {
          return (
            <Grid item xs={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={isEdit}
                    checked={timesheetData[index]?.value}
                    onChange={(e) => {
                      let items = [...timesheetData];
                      let item = { ...items[index] };
                      item = {
                        name: data.name,
                        tab: data.tab,
                        value: !data.value
                      };
                      items[index] = item;
                      setTimesheetData(items);
                    }}
                  />
                }
                label={data.name}
              />
            </Grid>
          );
        })}
      </Grid>
      <Grid container>
        <Grid item xs={12} sx={{ mt: 1 }}>
          <Typography sx={{ pt: 2 }} variant="h5">
            Employee Timesheet
          </Typography>
        </Grid>
        <Grid item xs={12} sx={{ mt: 2 }}>
          <FormControlLabel
            id="employee-timesheet-form-all"
            control={
              <Checkbox
                id="employee-timesheet-all"
                disabled={isEdit}
                checked={EmployeTimesheetData.every((dash) => dash.value)}
                onClick={(e) =>
                  onClickAll(EmployeTimesheetData, 'common', setEmployeeTimesheetData, e)
                }
              />
            }
            label="All"
          />
        </Grid>
        {EmployeTimesheetData.map((data, index) => {
          return (
            <Grid item xs={6} key={index}>
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={isEdit}
                    checked={EmployeTimesheetData[index]?.value}
                    onChange={() => {
                      let items = [...EmployeTimesheetData];
                      let item = { ...items[index] };
                      item = {
                        name: data.name,
                        tab: data.tab,
                        value: !data.value
                      };
                      items[index] = item;
                      setEmployeeTimesheetData(items);
                    }}
                  />
                }
                label={data.name}
              />
            </Grid>
          );
        })}
      </Grid>

      <Grid container>
        <Grid item xs={12} sx={{ mt: 1 }}>
          <Typography sx={{ pt: 2 }} variant="h5">
            Task Assignment
          </Typography>
        </Grid>
        <Grid item xs={12} sx={{ mt: 2 }}>
          <FormControlLabel
            id="task-assignment-form-all"
            control={
              <Checkbox
                id="task-assignment-all"
                disabled={isEdit}
                checked={taskAssignmentData.every((dash) => dash.value)}
                onClick={(e) =>
                  onClickAll(taskAssignmentData, 'common', setTaskAssignmentData, e)
                }
              />
            }
            label="All"
          />
        </Grid>
        {taskAssignmentData.map((data, index) => {
          return (
            <Grid item xs={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={isEdit}
                    checked={taskAssignmentData[index]?.value}
                    onChange={(e) => {
                      let items = [...taskAssignmentData];
                      let item = { ...items[index] };
                      item = {
                        name: data.name,
                        tab: data.tab,
                        value: !data.value
                      };
                      items[index] = item;
                      setTaskAssignmentData(items);
                    }}
                  />
                }
                label={data.name}
              />
            </Grid>
          );
        })}
      </Grid>
      <Grid container>
        <Grid item xs={12} sx={{ mt: 1 }}>
          <Typography sx={{ pt: 2 }} variant="h5">
            Time Entry
          </Typography>
        </Grid>
        <Grid item xs={12} sx={{ mt: 2 }}>
          <FormControlLabel
            id="time-entry-form-all"
            control={
              <Checkbox
                id="time-entry-all"
                disabled={isEdit}
                checked={timeEntryData.every((dash) => dash.value)}
                onClick={(e) =>
                  onClickAll(timeEntryData, 'common', setTimeEntryData, e)
                }
              />
            }
            label="All"
          />
        </Grid>
        {timeEntryData.map((data, index) => {
          return (
            <Grid item xs={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={isEdit}
                    checked={timeEntryData[index]?.value}
                    onChange={(e) => {
                      let items = [...timeEntryData];
                      let item = { ...items[index] };
                      item = {
                        name: data.name,
                        tab: data.tab,
                        value: !data.value
                      };
                      items[index] = item;
                      setTimeEntryData(items);
                    }}
                  />
                }
                label={data.name}
              />
            </Grid>
          );
        })}
      </Grid>
      <Grid container>
        <Grid item xs={12} sx={{ mt: 1 }}>
          <Typography sx={{ pt: 2 }} variant="h5">
            Reports
          </Typography>
        </Grid>
        <Grid item xs={12} sx={{ mt: 2 }}>
          <FormControlLabel
            id="detail-report-form-all"
            control={
              <Checkbox
                id="detail-report-all"
                disabled={isEdit}
                checked={
                  detailReportData.every((dash) => dash.value) &&
                  summarizedReportData.every((dash) => dash.value)&&
                  taskBasedReportData.every((dash) => dash.value) &&
                  varianceReportData.every((dash) => dash.value)
                }
                onClick={(e) => {
                  // Update both detailReport and summarizedReport
                  onClickAll(detailReportData, 'common', setDetailReportData, e)
                  onClickAll(summarizedReportData, 'common', setSummarizedReportData, e)
                  onClickAll(taskBasedReportData, 'common', setTaskBasedReportData, e)
                  onClickAll(varianceReportData, 'common', setVarianceReportData, e)  
                }
                }
              />
            }
            label="All"
          />
        </Grid>
        {detailReportData.map((data, index) => {
          return (
            <Grid item xs={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={isEdit}
                    checked={detailReportData[index]?.value}
                    onChange={(e) => {
                      let items = [...detailReportData];
                      let item = { ...items[index] };
                      item = {
                        name: data.name,
                        tab: data.tab,
                        value: !data.value
                      };
                      items[index] = item;
                      setDetailReportData(items);
                    }}
                  />
                }
                label={data.name}
              />
            </Grid>
          );
        })}
        {summarizedReportData.map((data, index) => {
          return (
            <Grid item xs={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={isEdit}
                    checked={summarizedReportData[index]?.value}
                    onChange={(e) => {
                      let items = [...summarizedReportData];
                      let item = { ...items[index] };
                      item = {
                        name: data.name,
                        tab: data.tab,
                        value: !data.value
                      };
                      items[index] = item;
                      setSummarizedReportData(items);
                    }}
                  />
                }
                label={data.name}
              />
            </Grid>
          );
        })}
        {taskBasedReportData.map((data, index) => {
          return (
            <Grid item xs={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={isEdit}
                    checked={taskBasedReportData[index]?.value}
                    onChange={(e) => {
                      let items = [...taskBasedReportData];
                      let item = { ...items[index] };
                      item = {
                        name: data.name,
                        tab: data.tab,
                        value: !data.value
                      };
                      items[index] = item;
                      setTaskBasedReportData(items);
                    }}
                  />
                }
                label={data.name}
              />
            </Grid>
          );
        })}
      {varianceReportData.map((data, index) => {
                return (
                  <Grid item xs={6}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          disabled={isEdit}
                          checked={varianceReportData[index]?.value}
                          onChange={(e) => {
                            let items = [...varianceReportData];
                            let item = { ...items[index] };
                            item = {
                              name: data.name,
                              tab: data.tab,
                              value: !data.value
                            };
                            items[index] = item;
                            setVarianceReportData(items);
                          }}
                        />
                      }
                      label={data.name}
                    />
                  </Grid>
                );
              })}
      </Grid>
    </>
  );
};

export default TabTen;
